import { provideEffects } from '@ngrx/effects';
import { provideState } from '@ngrx/store';

import { AskTicketsEffects } from './tickets.effects';
import { AskTicketsNamespace, AskTicketsReducer } from './tickets.state';

export const askTicketsStoreProvider = provideState(AskTicketsNamespace, AskTicketsReducer);
export const askTicketsEffectsProvider = provideEffects([AskTicketsEffects]);
